export default __webpack_public_path__ + "static/media/truck-icon-red.40d08ce7.svg";